import { render } from "./MicrosoftErrorModal.vue?vue&type=template&id=64be7480&scoped=true"
import script from "./MicrosoftErrorModal.vue?vue&type=script&lang=js"
export * from "./MicrosoftErrorModal.vue?vue&type=script&lang=js"

import "./MicrosoftErrorModal.vue?vue&type=style&index=0&id=64be7480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64be7480"]])

export default __exports__